<script>
import { ref } from 'vue'

import { TIME_RANGE_VARIABLES } from './_search-criterion-predicate-config.js'

export default {
  name: 'DateTimeWithVariablesInput',
  emits: ['update:modelValue'],
  props: {
    label: {
      type: String,
      required: true,
    },
    // modelVale -> string (as date) || in 'specific' case its [string (as date), string (as date)]
    modelValue: {
      type: String || [String, String],
    },
    name: {
      type: String,
      required: true,
    },
    skipDirtyCheck: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return {
      datetimeChosenVariables: ref({}),
      showPicker: ref(
        props.modelValue?.length && !Object.keys(TIME_RANGE_VARIABLES).includes(props.modelValue),
      ),
      timestampBetween: ref(
        typeof props.modelValue === 'object' && props.modelValue !== null ? props.modelValue : null,
      ),
    }
  },
  computed: {
    chosenVariable: {
      get() {
        if (Object.keys(TIME_RANGE_VARIABLES).includes(this.modelValue)) {
          return this.modelValue
        } else if (this.modelValue?.length || this.showPicker) {
          return 'specific'
        } else {
          return null
        }
      },
      set(newVal) {
        if (newVal == 'specific') {
          this.showPicker = true
          this.$emit('update:modelValue', null)
        } else {
          if (!newVal?.length) {
            this.showPicker = false
          }
          this.$emit('update:modelValue', newVal)
        }
      },
    },
    chosenTimestampBetween: {
      get() {
        if (Object.keys(TIME_RANGE_VARIABLES).includes(this.modelValue) || !this.showPicker) {
          return null
        } else {
          return this.timestampBetween
        }
      },
      set(newVal) {
        if (this.chosenVariable === 'specific') {
          this.timestampBetween = newVal
        } else this.timestampBetween = null
      },
    },
    variablesSelectorOptions() {
      const result = Object.keys(TIME_RANGE_VARIABLES).map(k => ({
        value: k,
        label: TIME_RANGE_VARIABLES[k],
      }))
      result.push({ value: 'specific', label: 'Specific value' })
      return result
    },
  },
  watch: {
    timestampBetween() {
      if (this.chosenVariable === 'specific') {
        this.$emit('update:modelValue', this.chosenTimestampBetween)
      }
    },
  },
  methods: {
    onSelectSpecificValue() {
      this.chosenVariable = 'specific'
      this.$nextTick(() => {
        this.$refs.datetimePicker?.focus?.()
      })
    },
  },
}
</script>

<template lang="pug">
ea-select.select-nowrap(
  :label="label"
  :name="`${name}.variablesSelector`"
  :options="variablesSelectorOptions"
  :reduce="item => item.value"
  :skipDirtyCheck="skipDirtyCheck"
  v-model="chosenVariable"
  input-size="sm"
  select-label="label"
)
  template(v-if="chosenVariable != 'specific'" #input-prepend)
    a.d-flex.align-items-center.justify-content-center.p-2(v-tooltip="'Specific value'")
      i.fa.fa-calendar.text-primary.cursor-pointer(@click="onSelectSpecificValue")

.d-flex.align-items-stretch.justify-content-start.flex-column-reverse.mt-2.w-100(
  v-if="chosenVariable == 'specific'"
)
  .border-none
    ea-datetimepicker(
      ref="datetimePicker"
      v-if="chosenVariable == 'specific'"
      :additional-errors="additionalErrors"
      :clearable="true"
      :config="{ mode: 'range', position: 'bottom right' }"
      :disabled="disabled"
      :errorsTeleport="teleportIsSet ? `#${teleportId}` : null"
      :initialVisibleDate="defaultDate"
      :inputClasses="'form-control-sm'"
      :modeRange="true"
      :name="`${name}Date`"
      :skipDirtyCheck="skipDirtyCheck"
      :timeZone="$store.state.session.timeZone"
      :validators="validators"
      v-model="chosenTimestampBetween"
      hideInvalidIcon
    )
</template>
